<!--
 * @Author: Gaho
 * @Date: 2024-03-14 16:20:10
 * @LastEditors: Gaho
 * @LastEditTime: 2024-10-17 15:35:49
 * @Description: 
-->
<template>
    <div class="plinko-svg">
        <div class="plinko-multiple" :class="`plinko-multiple-${rowsModel}`">
            <div
                v-for="(v, k) in odds[riskModel][rowsModel]"
                class="h-[16px] leading-4 text-center w-[24px] ml-0.5 fz-8 rounded-borders plinko-unit"
                :class="Object.values(activeBall).includes(k) ? 'current-multi' : ''"
                :key="k"
                :style="`filter: ${Object.values(activeBall).includes(k) ? `drop-shadow(0px 1px 6px ${v.color});` : 'none'}`"
            >
                <!-- 赢分&机会 start -->
                <div
                    class="chance-tooltip"
                    :style="`transform: translateY(-100%) translateX(${
                        -6.5 - (80 / rowsModel) * k
                    }%)`"
                >
                    <div class="chance-tooltip-content">
                        <!-- 赢分 -->
                        <div>
                            <p class="chance-label">{{ $t('winAmount') }}</p>
                            <p class="chance-value">
                                <span style="display: inline-flex; align-items: center">
                                    <CurrentCoin class="w-[16px] h-[16px]" />
                                    <span style="margin: 0 4px">
                                        <span>
                                            {{ getFixed(Number(winAmount(oForm.amount, v.mutil))) }}
                                        </span>
                                    </span>
                                </span>
                                <span>{{
                                    userStore.oNowCurrency.currencyName.toLocaleUpperCase()
                                }}</span>
                            </p>
                        </div>
                        <!-- 机会 -->
                        <div>
                            <p class="chance-label">{{ $t('chance') }}</p>
                            <p class="chance-value">{{ v.chance }}%</p>
                        </div>
                    </div>
                    <div
                        class="tooltip-triangle"
                        :style="`left:${15 + (70 / rowsModel) * k - (5 - (10 / rowsModel) * k)}%;`"
                    ></div>
                </div>
                <!-- 赢分&机会 end -->
                <span class="multiple-svg" v-html="setSvg(v.color, v.mutil + 'x')"></span>
            </div>
        </div>
        <!-- plinko name -->
        <div class="plinko-name" v-if="rowsModel === 16">
            <span v-for="val in list" :key="val" class="name-val">
                {{ val }}
            </span>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { winAmount, setAmountZero } from '../../utils/index';
import { useUserStore } from '~/stores/user';
import { lettersList } from '../../data/oddsData';
export default defineComponent({
    name: 'plinkoMultiRows',
    props: {
        odds: {
            type: Object,
            default: () => ({}),
        },
        rowsModel: {
            type: Number,
            default: 16,
        },
        riskModel: {
            type: String,
            default: 'Meduim',
        },
        // 目前暂时已废弃，替换为activeBall
        active: { 
            type: Array<any>,
            default: () => [],
        },
        oForm: {
            type: Object,
            default: () => ({}),
        },
        activeBall: {
            type: Object,
            default: () => ({}),
        }
    },
    data() {
        return {
            userStore: useUserStore(),
            list: lettersList,
        };
    },
    methods: {
        winAmount,
        setAmountZero,
        /**
         * 根据风险设置对应的svg
         * @param {string} color 颜色值
         * @param {string} value 倍数
         */
        setSvg(color: string, value: string) {
            let fill = color;
            return `<svg width="100%" height="100%" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 1.72C0 .32 1.76-.48 2.89.32 5.08 1.9 8.25 3.65 11.5 3.65c3.25 0 6.42-1.75 8.61-3.31 1.13-.8 2.89 0 2.89 1.4v14.65A2.6 2.6 0 0 1 20.42 19H2.58A2.6 2.6 0 0 1 0 16.38V1.72Z" fill=${fill}></path><foreignObject x="0" y="0" width="100%" height="100%" style="display:flex;align-items:center;justify-content: center;padding-top: 3px;"> <p class="svg-foreignObject">${value}</p> </foreignObject><g opacity=".48" filter="url(#a)"><path d="M0 1.71C0 .31 1.76-.49 2.89.32 5.08 1.9 8.25 3.64 11.5 3.64c3.25 0 6.42-1.75 8.61-3.32 1.13-.8 2.89 0 2.89 1.4v1.5c0-.34-.43-1.8-1.85-1.8-1.43 0-4.46 3.76-9.65 3.76-5.2 0-7.79-3.76-9.65-3.76C.43 1.42 0 2.52 0 3.22v-1.5Z" fill="#fff"></path></g><defs><filter id="a" x="0" y="0" width="23" height="5.18" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="2.08"></feOffset><feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"></feComposite><feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.48 0"></feColorMatrix><feBlend in2="shape" result="effect1_innerShadow_2174_144025"></feBlend></filter></defs></svg>`;
        },
    },
});
</script>
<style lang="scss" scoped>
.plinko-svg {
    bottom: 0;
    display: flex;
    flex-direction: column;
    height: 13.6%;
    left: 0;
    padding: 0 18.8%;
    position: absolute;
    right: 0;

    @media (max-width: 460px) {
        & > div {
            padding-bottom: 0;
            padding-top: 0;
        }
    }

    .plinko-multiple {
        width: 100%;
        display: flex;
        height: 33.5%;
        margin-bottom: 2.5%;

        .plinko-unit {
            flex: 1;
            cursor: pointer;
            font-size: 8px;
            position: relative;

            &:nth-of-type(1) {
                margin-left: 0;
            }
            &:hover {
                .chance-tooltip {
                    display: block;
                }
            }
        }
    }
    .plinko-multiple-8{
        height: 54%;
        .plinko-unit {
            font-size: 12px;
        }
    }
    .plinko-multiple-9{
        height: 50.5%;
        .plinko-unit {
            font-size: 10px;
        }
    }
    .plinko-multiple-10{
        height: 50.5%;
        .plinko-unit {
            font-size: 9px;
        }
    }
    .plinko-multiple-11{
        height: 45.5%;
        .plinko-unit {
            font-size: 8px;
        }
    }
    .plinko-multiple-12{
        height: 39.5%;
        .plinko-unit {
            font-size: 8px;
        }
    }
    .plinko-multiple-13{
        height: 33.5%;
        .plinko-unit {
            font-size: 8px;
        }
    }
    .plinko-multiple-14{
        height: 31.5%;
        .plinko-unit {
            font-size: 8px;
        }
    }
    .plinko-multiple-15{
        height: 28.5%;
        .plinko-unit {
            font-size: 8px;
        }
    }
    .plinko-multiple-16{
        height: 33.5%;
        .plinko-unit {
            font-size: 8px;
        }
    }

    .plinko-name {
        display: flex;
        justify-content: space-between;
        margin-bottom: 0;
        height: 32%;
        user-select: none;

        .name-val {
            color: #fff;
            font-size: 12px;
            font-weight: 600;
            letter-spacing: -0.02em;
            line-height: 11px;
            display: inline-block;
            align-items: center;
            display: flex;
            flex: 1;
            justify-content: center;
            margin-right: 0.3%;
            padding: 2px;
            position: relative;
            white-space: nowrap;
            background: #0f1125;
            border: 1px solid #201b38;
            border-radius: 3.47806px;
        }
    }

    @media (max-width: 460px) {
        .plinko-name {
            height: 36%;
            max-height: 17.5px;
        }
    }
}

@media (max-width: 460px) {
    .plinko-svg {
        bottom: 0;
        height: 8.6%;
        padding: 0 4.8%;
    }
}

.multiple-svg {
    position: relative;
    display: inline-block;

    svg {
        height: auto;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
    }

    :deep(.svg-foreignObject) {
        color: #fff;
        font-size: 8px;
        font-weight: 600;
        text-shadow: 0 0.770775px 1.54155px #095c21;
        white-space: nowrap;
    }

    @media (max-width: 460px) {
        .svg-foreignObject {
            padding-top: 28%;
        }
    }
}
.chance-tooltip {
    background: #212655;
    display: none;
    position: absolute;
    top: -10px;
    z-index: 1;
    transform: translateY(-100%) translateX(5%);
    border-radius: 8px;
    padding: 10px 12px;
}

.chance-tooltip-content {
    display: flex;

    div {
        color: #93acd3;
        font-size: 12px;
        font-weight: 600;
        line-height: 16px;
        width: max-content;

        &:nth-of-type(1) {
            margin-right: 8px;
        }

        .chance-label {
            margin-bottom: 8px;
            text-align: start;
            color: #ffffff80;
        }

        .chance-value {
            background: #000;
            border-radius: 10px;
            padding: 8px 16px 8px 12px;
            display: flex;
            align-items: center;
            font-size: 12px;

            &:nth-of-type(2) {
                color: #fff;
                letter-spacing: -0.02em;
            }
        }
    }
}
.tooltip-triangle {
    background: #212655;
    bottom: -10px;
    height: 12px;
    left: 50%;
    position: absolute;
    transform: translate(-50%, -50%) rotate(45deg);
    width: 12px;
    will-change: transform;
}
.current-multi {
    animation: win-animation .2s ease-in-out;
    transition: all .2s;
    will-change: transform;
}
@keyframes win-animation {
    0% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(20%);
    }
    to {
        transform: translateY(0);
    }
}
</style>